module.exports = __webpack_public_path__ + "img/image 21.9e21406e.png";